import { render, staticRenderFns } from "./ChallengeGrid.vue?vue&type=template&id=1cfb349c&scoped=true"
import script from "./ChallengeGrid.vue?vue&type=script&lang=js"
export * from "./ChallengeGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cfb349c",
  null
  
)

export default component.exports